<template>
	<details
		v-for="(item, index) in props.items"
		:key="index"
		:open="index === 0"
		class="c_details"
		@toggle="onClickDetails"
	>
		<summary class="summary">
			<div class="c_inner">
				<div class="bookmark">{{ index + 1 }}</div>
				<div class="content">
					<img :src="item.master_file_path" alt="대가 이미지" loading="lazy" />
					<div class="content_title">
						<div class="company">
							<div class="img_box">
								<img class="company_img" :src="item.event_file_path" alt="종목 이미지" />
							</div>
							<div class="company_txt ellipsis">{{ item.event_name }}</div>
						</div>
						<div class="master ellipsis">{{ item.master_name }}</div>
					</div>
				</div>
			</div>
			<div class="content_total">{{ formatWithSign(item.best_rise_ratio) }}%</div>
		</summary>
		<div class="c_editorContent content_bottom">
			<div v-if="!item.best_rise_file_path" class="img_box">
				<img src="@/assets/img/bi/bi_dark.svg" alt="bi" loading="lazy" />
			</div>
			<img v-else :src="item.best_rise_file_path" alt="종목 이미지" loading="lazy" />
			<div class="btn_box">
				<button
					class="c_button primary-fill radius-full btn-research"
					@click="onClickResearch(item.event_pk, item.master_pk)"
				>
					분석
				</button>
			</div>
		</div>
	</details>
</template>

<script setup lang="ts">
import { BestRiseOne } from '@/api/home';
import router from '@/router';
import { formatWithSign } from '@/utils/function/format';
import { useHeaderStore } from '@/stores/header';

// -----variable-----
const props = defineProps<{
	items?: BestRiseOne[];
}>();
const headerStore = useHeaderStore();

// -----function-----
// 다중 열림 방지 기능
const onClickDetails = (e: Event) => {
	const toggled = e.target as HTMLDetailsElement;
	console.log(toggled);
	if (toggled && toggled.hasAttribute('open')) {
		toggled.classList.add('open');
		document.querySelectorAll('details[open]').forEach((element) => {
			console.log('element:', element);
			if (toggled !== element) {
				(element as HTMLDetailsElement).removeAttribute('open');
				(element as HTMLDetailsElement).classList.remove('open');
			}
		});
	} else {
		toggled.classList.remove('open');
	}
};
// 분석 버튼 클릭 시 실행 함수
const onClickResearch = async (eventpk: number, masterPk: number) => {
	console.log(`headerStore.getCountry: ${headerStore.getCountry}`);
	if (headerStore.getCountry === 'JPN') {
		router.push(`/report/jpn/${eventpk}/${masterPk}`);
	} else if (headerStore.getCountry === 'USA') {
		router.push(`/report/usa/${eventpk}/${masterPk}`);
	}
};
</script>

<style lang="scss" scoped>
.summary {
	padding-right: 1rem;
	background-color: var(--color-bg-mid);
	border-radius: var(--space-x-small);
	gap: 0.8rem;
	display: flex;
	justify-content: space-between;
	align-items: center;

	.c_inner {
		display: flex;
		flex: 1;
		min-width: 0;
		height: 9rem;
		color: var(--color-base-white);
		padding: 0;
		.bookmark {
			display: flex;
			align-items: center;
			justify-content: center;
			background-color: var(--color-bg-light);
			border-radius: var(--space-x-small) 0 0 var(--space-x-small);
			font-weight: var(--font-w-semi-bold);
			font-size: var(--space-large);
			line-height: 2.387rem;
			width: 3.4rem;
			flex-shrink: 0;
		}
		.content {
			display: flex;
			gap: 0.8rem;
			align-items: center;
			padding: 1.6rem 0rem 1.6rem 1rem;
			flex: 1;
			min-width: 0;
			img {
				object-fit: contain;
				width: 5.2rem;
				height: 4.8rem;
				flex-shrink: 0;
			}
			&_title {
				display: flex;
				flex-direction: column;
				gap: var(--space-xx-small);
				min-width: 0;
				flex: 1;
				.company {
					display: flex;
					align-items: center;
					gap: 0.4rem;
					font-size: var(--font-s-mid);
					color: var(--color-base-white);
					font-weight: var(--font-w-semi-bold);
					line-height: normal;
					min-width: 0;
					.img_box {
						display: flex;
						align-items: center;
						justify-content: center;
						width: 2.4rem;
						height: 2.4rem;
						background-color: #202020;
						border-radius: 44%;
						flex-shrink: 0;
						.company_img {
							object-fit: cover;
							border-radius: 44%;
							width: 100%;
							height: 100%;
						}
					}
					&_txt {
						min-width: 0;
					}
				}
				.master {
					font-size: var(--font-s-small);
					color: var(--color-base-light);
					font-weight: var(--font-w-light);
					line-height: normal;
				}
			}
		}
	}
	.content_total {
		color: var(--color-danger);
		font-weight: var(--font-w-semi-bold);
		font-size: var(--font-s-regular);
		line-height: 2.1rem;
		white-space: nowrap;
		flex-shrink: 0;
		margin-left: 1rem;
	}
}
.ellipsis {
	white-space: nowrap;
	overflow: hidden;
	text-overflow: ellipsis;
	width: 100%;
}
.content_bottom {
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	padding: 1.6rem;
	gap: 2.4rem;
	background-color: var(--color-bg-mid);
	border-radius: 0rem 0rem var(--space-x-small) var(--space-x-small);
	.img_box {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 100%;
		max-height: 46.2rem;
		height: auto;
		aspect-ratio: 1 / 1;
		background-color: var(--color-base-light);
		img {
			width: 8rem;
			height: 8rem;
		}
	}
	.btn_box {
		display: flex;
		.btn-research {
			display: flex;
			height: auto;
			padding: 6px 16px;
			justify-content: center;
			align-items: center;
			gap: 10px;
		}
	}
}
.c_details[open] summary .bookmark {
	border-radius: 0.8rem 0 0 0;
}

.c_details[open] summary {
	border-radius: 0rem var(--space-x-small);
}
</style>
